import axiosInstance from '../../../../services/axios/axios';
import { WrapImsPacket } from '../../../../store/utility';
// import { ReactElement } from 'react';

/**
 * Get list of work queue results for the user
 *
 */
export const fetchWorkQueue = async workQueueArgs => {
	try {
		const response = await axiosInstance.post(
			`api/WorkQueue/GetRequests`,
			WrapImsPacket(workQueueArgs)
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch work queue results: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Get list of work queue names which do not have ability for bulk approve
 *
 */
export const fetchUnableBulkApprove = async workQueueArgs => {
	try {
		const response = await axiosInstance.get(
			`api/WorkQueue/GetItemsNotForBulkApprove`
		);

		return response;
	} catch (ex) {
		console.error(
			'Unable to fetch requests unable for bulk approval: ' + ex
		);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};

/**
 * Approves all selected requests
 *
 */
export const approveAllRequestsSelected = async workQueueArgs => {
	var response;
	try {
		response = await axiosInstance.post(
			`api/WorkQueue/ApproveAllRequests`,
			WrapImsPacket(workQueueArgs)
		);

		return response;
	} catch (ex) {
		console.error('Response Error: ', ex);
		return {
			data: [],
			error: ex?.response?.data?.payload,
		};
	}
};

/**
 * Get array of non actionable requests -- Use the Key returned to determine if that key exists within the original set of rows
 *
 */
export const getAllNotActionableRequests = async workQueueArgs => {
	try {
		const response = await axiosInstance.post(
			`api/WorkQueue/FindAllRequestsNotActionable`,
			WrapImsPacket(workQueueArgs)
		);

		return response;
	} catch (ex) {
		console.error('Unable to fetch results: ' + ex);
		return {
			data: [],
			error: 'An Error Occurred Fetching data from the server',
		};
	}
};
